import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { FormContainerComponent } from "../../components/ui-components/forms/form-container/form-container.component";
import { FormInputComponent } from "../../components/ui-components/forms/form-input/form-input.component";
import { CardButtonComponent } from "../../components/ui-components/buttons/card-button/card-button.component";
import { DropdownComponent } from "../../components/ui-components/dropdown/dropdown.component";
import { StateService } from "../../services/state.service";
import { PopUpDialogConfirmService } from "../../services/confirms/popUpDialogConfirmService.service";
import {
  CardButtonBackground,
  CardButtonSize,
} from "../../components/ui-components/buttons/card-button/card-button.model";
import { FormInputType } from "../../components/ui-components/forms/form-input/form-input.model";
import { SaleTripService } from "../sale/sale-trip/sale-trip.service";

@Component({
  selector: "app-return",
  templateUrl: "./return.component.html",
  styleUrls: ["./return.component.scss"],
  imports: [
    TranslateModule,
    CardButtonComponent,
    FormContainerComponent,
    DropdownComponent,
    FormInputComponent,
    CommonModule,
  ],
  standalone: true,
})
export class ReturnComponent {
  private readonly _router = inject(Router);
  private _saleTripService = inject(SaleTripService);
  private readonly _state = inject(StateService);
  private readonly _popUpDialogConfirmService = inject(
    PopUpDialogConfirmService
  );

  CardButtonSize = CardButtonSize;
  CardButtonBackground = CardButtonBackground;

  ngOnInit() {
    this.checkWaitingTripReturn();
  }

  public async searchTrip(bnr?: string) {
    this._saleTripService.searchTrip(bnr, true);
  }

  // TO DO - needed ?
  public goToReturnTrip() {
    this._router.navigate(["trip-return"]);
  }

  // TO DO - needed ?
  public goToReturnFlyTicket() {
    this._router.navigate(["fly-ticket-return"]);
  }

  public goToReturnETravelTicket() {
    this._router.navigate(["e-travel-return"]);
  }

  private async checkWaitingTripReturn() {
    const waitingTripReturn = this._state.waitingTripReturnId();
    if (waitingTripReturn !== null) {
      await this.searchTrip(waitingTripReturn);
      this._state.waitingTripReturnId.set(null);
    }
  }
}
